export const PERSON_PARAMETERS = "/personparameters";
export const BUILDING_PARAMETERS = "/buildingparameters";
export const SAVED_SEARCHES = "/personparameters/searchrequests";
export const TEMPORARY_SEARCHES = "/personparameters/searchrequests/temporary";
